import React from "react";
import { useIntl } from "react-intl";
import { styled } from "@mui/material/styles";

interface ClientProspectViewToggleProps {
    viewMode: string;
    onChange: () => void;
}

const ToggleContainer = styled("div")({
    display: "flex",
    position: "relative",
    backgroundColor: "#f4f4f4",
    borderRadius: "9999px",
    width: "fit-content",
    padding: "4px",
    cursor: "pointer",
});

const ToggleOption = styled("div")<{ selected?: boolean }>(({ selected }) => ({
    zIndex: 1,
    flex: 1,
    padding: "6px 12px",
    borderRadius: "9999px",
    fontSize: "0.875rem",
    fontWeight: 500,
    textAlign: "center",
    color: selected ? "#fff" : "black",
    transition: "color 0.2s ease-in-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "80px",
}));

const ToggleThumb = styled("div")<{ position: "left" | "right" }>(
    ({ position }) => ({
        position: "absolute",
        top: 4,
        left: position === "left" ? 4 : "calc(50% + 2px)",
        width: "calc(50% - 6px)",
        height: "calc(100% - 8px)",
        borderRadius: "9999px",
        backgroundColor: "#3e3e3e",
        transition: "left 0.25s ease-in-out",
    })
);

const ClientProspectViewToggle = ({
    viewMode,
    onChange,
}: ClientProspectViewToggleProps) => {
    const intl = useIntl();

    return (
        <ToggleContainer role="group" aria-label="View Mode Toggle">
            <ToggleThumb
                position={viewMode === "prospects" ? "right" : "left"}
            />
            <ToggleOption selected={viewMode === "clients"} onClick={onChange}>
                {intl.formatMessage({
                    id: "button.listView",
                    defaultMessage: "Clients",
                })}
            </ToggleOption>
            <ToggleOption
                selected={viewMode === "prospects"}
                onClick={onChange}
            >
                {intl.formatMessage({
                    id: "button.weeklyView",
                    defaultMessage: "Prospects",
                })}
            </ToggleOption>
        </ToggleContainer>
    );
};

export default ClientProspectViewToggle;
